import React from "react";
import "./circleloading.css"

const CircleLoading = () => {
  return (
    <div style={{display:"flex",justifyContent:"center"}}>
    <div class="dot-spinner">
      <div class="dot-spinner__dot"></div>
      <div class="dot-spinner__dot"></div>
      <div class="dot-spinner__dot"></div>
      <div class="dot-spinner__dot"></div>
      <div class="dot-spinner__dot"></div>
      <div class="dot-spinner__dot"></div>
      <div class="dot-spinner__dot"></div>
      <div class="dot-spinner__dot"></div>
    </div>
    </div>
  );
};

export default CircleLoading;
